"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var constants_1 = require("../constants");
var services_1 = require("../generated/services");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../generated/services/customer-client.service"));
var i2 = __importStar(require("../generated/services/customer-activity-history-client.service"));
var i3 = __importStar(require("../generated/services/customer-contact-history-client.service"));
var CustomerService = /** @class */ (function () {
    function CustomerService(customerClient, customerActivityHistoryClient, customerContactHistoryClient) {
        this.customerClient = customerClient;
        this.customerActivityHistoryClient = customerActivityHistoryClient;
        this.customerContactHistoryClient = customerContactHistoryClient;
    }
    CustomerService.prototype.getCustomerActivities = function (entityId) {
        return this.customerActivityHistoryClient.GetCustomerActivityHistoryByEntityidGET(entityId).toPromise();
    };
    CustomerService.prototype.getCustomer = function (entityId) {
        var _this = this;
        return rxjs_1.forkJoin(this.customerClient.ByEntityByEntityidGET(entityId), this.customerContactHistoryClient.GetCustomerAdditionalContactsByEntityidGET(entityId))
            .pipe(operators_1.map(function (_a) {
            var customer = _a[0], customerAdditionalContact = _a[1];
            return _this.resolveCustomer(customer, customerAdditionalContact);
        })).toPromise();
    };
    CustomerService.prototype.getCustomerName = function (entityId) {
        var _this = this;
        return this.customerClient.GetNameOnlyByEntityidGET(entityId)
            .pipe(operators_1.map(function (result) {
            return _this.resolveCustomer(result, null);
        })).toPromise();
    };
    CustomerService.prototype.stageDoNotEmailList = function (emailList) {
        return this.customerClient.InsertDoNotEmailStagingPOST(emailList);
    };
    CustomerService.prototype.stageDoNotCallList = function (phoneNumberList) {
        return this.customerClient.InsertDoNotCallStagingPOST(phoneNumberList);
    };
    CustomerService.prototype.finishDoNotEmailList = function (sessionId) {
        return this.customerClient.CustomerMarkDoNotEmailPOST({ sessionID: sessionId, hypothetical: false });
    };
    CustomerService.prototype.finishDoNotCallList = function (sessionId) {
        return this.customerClient.CustomerMarkDoNotCallPOST({ sessionID: sessionId, hypothetical: false });
    };
    CustomerService.prototype.getCustomerCultureByCode = function (code) {
        if (code == null)
            return null;
        var cultureObj = constants_1.CustomerCultures.find(function (culture) {
            return culture.name.toLowerCase() == code.toLowerCase();
        });
        return cultureObj != null ? cultureObj.displayName : null;
    };
    CustomerService.prototype.resolveCustomer = function (customer, contactHistory) {
        var invalidContacts = customer.invalidContacts ? customer.invalidContacts.split(',') : [];
        var createPreferredContact = function (value, contactType, doNotCallStatusTypeId) {
            if (value) {
                return {
                    contactType: contactType,
                    value: value,
                    isBad: lodash_1.default.includes(invalidContacts, value),
                    isPreferred: true,
                    doNotCallStatusTypeId: doNotCallStatusTypeId
                };
            }
        };
        var createAlternateContacts = function () {
            var alternateContacts = [];
            var contactExistsInCollection = function (contact) {
                return lodash_1.default.some(alternateContacts, function (p) {
                    return p.contactType === contact.contactID
                        && p.value === contact.contactValue;
                });
            };
            var contactIsAPreferredContact = function (contact) {
                switch (contact.contactID) {
                    case constants_1.ContactTypes.homePhone: return customer.homePhone === contact.contactValue;
                    case constants_1.ContactTypes.workPhone: return customer.workPhone === contact.contactValue;
                    case constants_1.ContactTypes.cellPhone: return customer.cellPhone === contact.contactValue;
                    case constants_1.ContactTypes.email: return customer.email === contact.contactValue;
                }
            };
            if (contactHistory) {
                contactHistory.forEach(function (contact) {
                    if (!contactExistsInCollection(contact) && !contactIsAPreferredContact(contact)) {
                        alternateContacts.push({
                            contactType: contact.contactID,
                            value: contact.contactValue,
                            isBad: lodash_1.default.includes(invalidContacts, contact.contactValue),
                            doNotCallStatusTypeId: contact.doNotCallStatusTypeId
                        });
                    }
                });
            }
            return alternateContacts;
        };
        var resolvedCustomer = {
            id: customer.customerID,
            isFullCustomer: customer.isFullCustomer,
            isAddressNotValid: customer.isAddressNotValid,
            firstName: customer.firstName,
            middleName: customer.middleName,
            lastName: customer.lastName,
            fullName: customer.fullName,
            companyName: customer.companyName,
            homePhoneNumber: createPreferredContact(customer.homePhone, constants_1.ContactTypes.homePhone, customer.homePhone_DoNotCallStatusTypeId),
            workPhoneNumber: createPreferredContact(customer.workPhone, constants_1.ContactTypes.workPhone, customer.workPhone_DoNotCallStatusTypeId),
            cellPhoneNumber: createPreferredContact(customer.cellPhone, constants_1.ContactTypes.cellPhone, customer.cellPhone_DoNotCallStatusTypeId),
            emailAddress: createPreferredContact(customer.email, constants_1.ContactTypes.email, invalidContacts),
            alternateContacts: createAlternateContacts(),
            doNotCall: customer.doNotCall,
            doNotEmail: customer.doNotEmail,
            doNotMail: customer.doNotMail,
            doNotText: customer.doNotText,
            address: {
                streetAddress: customer.address,
                streetAddress2: customer.address2,
                city: customer.city,
                stateId: customer.stateID,
                stateName: customer.state,
                zipCode: customer.zipCode,
                normalizedZipCode: customer.normalizedZipCode
            },
            pricingPlanId: customer.pricingPlanID,
            // We preserve this array so we can restore them when updating
            // the customer.
            invalidContacts: invalidContacts,
            preferredCultureName: customer.preferredCultureName,
            dealerID: customer.dealerID
        };
        return resolvedCustomer;
    };
    CustomerService.prototype.updateCustomer = function (customer) {
        var getUpdateCustomerRequest = function () {
            var homePhoneNumber = customer.homePhoneNumber && customer.homePhoneNumber.value !== undefined ? customer.homePhoneNumber.value : null;
            var workPhoneNumber = customer.workPhoneNumber && customer.workPhoneNumber.value !== undefined ? customer.workPhoneNumber.value : null;
            var cellPhoneNumber = customer.cellPhoneNumber && customer.cellPhoneNumber.value !== undefined ? customer.cellPhoneNumber.value : null;
            var emailAddress = customer.emailAddress && customer.emailAddress.value !== undefined ? customer.emailAddress.value : null;
            return {
                customerID: customer.id,
                firstName: customer.firstName,
                middleName: customer.middleName,
                lastName: customer.lastName,
                companyName: customer.companyName,
                address: customer.address.streetAddress,
                address2: customer.address.streetAddress2,
                city: customer.address.city,
                stateID: customer.address.stateId,
                state: customer.address.stateName,
                zipCode: customer.address.zipCode,
                homePhone: homePhoneNumber,
                workPhone: workPhoneNumber,
                cellPhone: cellPhoneNumber,
                invalidContacts: customer.invalidContacts ? customer.invalidContacts.join(',') : null,
                email: emailAddress,
                doNotCall: customer.doNotCall,
                doNotEmail: customer.doNotEmail,
                doNotMail: customer.doNotMail,
                fullName: getFullName(),
                pricingPlanID: customer.pricingPlanId,
                doNotText: customer.doNotText,
                preferredCultureName: customer.preferredCultureName
            };
        };
        var getFullName = function () {
            var fullName = customer.firstName;
            if (customer.middleName) {
                fullName += ' ' + customer.middleName;
            }
            if (customer.lastName) {
                fullName += ' ' + customer.lastName;
            }
            return fullName;
        };
        var request = getUpdateCustomerRequest();
        return this.customerClient.UpdatePATCHResponse(request)
            .pipe(operators_1.map(function (response) { return resolveCustomerUpdate(response); })).toPromise();
        function resolveCustomerUpdate(response) {
            return response.status === 204;
        }
    };
    CustomerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(i0.ɵɵinject(i1.CustomerClientService), i0.ɵɵinject(i2.CustomerActivityHistoryClientService), i0.ɵɵinject(i3.CustomerContactHistoryClientService)); }, token: CustomerService, providedIn: "root" });
    return CustomerService;
}());
exports.CustomerService = CustomerService;
